import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import ResponsiveContactUsPage from './components/ResponsiveContactUsPage.jsx';
import ResponsiveTeamPage from './components/ResponsiveTeamPage.jsx';
import ResponsiveHomePage from './components/ResponsiveHomePage.jsx';
import ResponsiveRunClubPage from './components/ResponsiveRunClubPage.jsx';
import ResponsiveJoinUsPage from './components/ResponsiveJoinUsPage.jsx';
import TermsAndConditions from './components/TermsAndConditions.jsx';
import PrivacyPolicy from './components/PrivacyPolicy.jsx';


function App() {
  return (
    <Router>
      <Routes>
        {/* Route paths and corresponding components */}
        <Route path="/" element={<ResponsiveHomePage />} />
        <Route path="/contact-us" element={<ResponsiveContactUsPage />} />
        <Route path="/team" element={<ResponsiveTeamPage />} />
        <Route path="/run-clubs" element={<ResponsiveRunClubPage />} />
        <Route path="/join-us" element={<ResponsiveJoinUsPage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  )
}

export default App;
